import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'sku.modifiers.library.heading',
    defaultMessage: 'Modifiers',
  },
  newModifier: {
    id: 'sku.modifiers.library.new-modifier',
    defaultMessage: 'New Modifier',
  },
  nameColumn: {
    id: 'sku.modifiers.library.name-column',
    defaultMessage: 'Name',
  },
  optionsColumn: {
    id: 'sku.modifiers.library.options-column',
    defaultMessage: 'Options',
  },
  usedInColumn: {
    id: 'sku.modifiers.library.used-in-column',
    defaultMessage: 'Used in',
  },
  availabilityColumn: {
    id: 'sku.modifiers.library.availability-column',
    defaultMessage: 'Availability',
  },
  actionsAriaLabel: {
    id: 'sku.modifiers.library.actions-aria-label',
    defaultMessage: 'Actions for {name}',
  },
  actionsColumn: {
    id: 'sku.modifiers.library.actions-column',
    defaultMessage: 'Actions',
  },
  rowAriaLabel: {
    id: 'sku.modifiers.library.row-aria-label',
    defaultMessage: 'Open {name}',
  },
  edit: {
    id: 'sku.modifiers.library.edit',
    defaultMessage: 'Edit',
  },
  duplicate: {
    id: 'sku.modifiers.library.duplicate',
    defaultMessage: 'Duplicate',
  },
  delete: {
    id: 'sku.modifiers.library.delete',
    defaultMessage: 'Delete',
  },
  duplicateModifier: {
    id: 'sku.modifiers.library.duplicate-modifier',
    defaultMessage: 'Duplicate modifier',
  },
  editModifierGroup: {
    id: 'sku.modifiers.library.edit-modifier-group',
    defaultMessage: 'Edit modifier group',
  },
  deleteModifierGroup: {
    id: 'sku.modifiers.library.delete-modifier-group',
    defaultMessage: 'Delete modifier group',
  },
  copyName: {
    id: 'sku.modifiers.library.copy-name',
    defaultMessage: '{name} (copy)',
  },
  deleteGroupDialogLabel: {
    id: 'sku.modifiers.library.delete-group-dialog-label',
    defaultMessage: 'Delete modifier',
  },
  deleteGroupTitle: {
    id: 'sku.modifiers.library.delete-group-title',
    defaultMessage: 'Delete <strong>{groupName}</strong>?',
  },
  deleteGroupUsedIn: {
    id: 'sku.modifiers.library.delete-group-used-in',
    defaultMessage:
      'It is used in {itemCount, plural, one {# item} other {# items}} ({itemNames}) and will be removed from all of them.',
  },
  deleteGroupUnused: {
    id: 'sku.modifiers.library.delete-group-unused',
    defaultMessage: 'This modifier will be removed from your library.',
  },
  deleteGroupUndone: {
    id: 'sku.modifiers.library.delete-group-undone',
    defaultMessage: 'This action cannot be undone.',
  },
  deleteGroupCancel: {
    id: 'sku.modifiers.library.delete-group-cancel',
    defaultMessage: 'Cancel',
  },
  deleteGroupAction: {
    id: 'sku.modifiers.library.delete-group-action',
    defaultMessage: 'Delete modifier',
  },
  deleteGroupFailed: {
    id: 'sku.modifiers.library.delete-group-failed',
    defaultMessage: 'We could not delete this modifier. Please try again.',
  },
  emptyTitle: {
    id: 'sku.modifiers.library.empty-title',
    defaultMessage: 'No modifiers yet',
  },
  emptySubtitle: {
    id: 'sku.modifiers.library.empty-subtitle',
    defaultMessage: 'Add a modifier to get started.',
  },
  loadError: {
    id: 'sku.modifiers.library.load-error',
    defaultMessage: 'We could not load your modifiers. Please try again.',
  },
});
